import { render, staticRenderFns } from "./MyBullsI.vue?vue&type=template&id=50b154da&"
import script from "./MyBullsI.vue?vue&type=script&lang=js&"
export * from "./MyBullsI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports